import React from 'react';
import { SectionAttention as Styled } from '../../styles/about';

/**
 * 注意事項
 */
const SectionAttention: React.FC = () => {
  return (
    <Styled>
      <a id="attention" />
      <h3>
        <span>注意事項</span>
      </h3>
      <p>■ 当社が規約違反と判断した場合、事前の告知なく掲示板の利用資格を取り消させていただく場合があります。</p>
      <p>
        ■ 当社では、個人情報保護方針に基づいたプライバシーの保護、会員情報の管理を行っておりますが、
        「投稿内容が他者の権利を侵害した」等の理由で、公権的な開示請求がなされた場合には、登録情報を開示せざるを得なくなる事もございます。
      </p>
      <p>
        ■ 専門職である看護師・看護学生専用のサイトとして、健全な運営を行っていくため、投稿内容が利用規約に違反している場合、
        ナース専科コミュニティ運営部の手により削除されます。違反のある投稿は、原則として投稿から24時間以内に監視され、削除されます。
        また、もしあなたが不適切な投稿を見つけたら、違反報告をすることができます。
        運営部は頂いた違反報告を厳正に審査し、投稿が不適切だと判断した場合、投稿を削除します。
      </p>
      <p>■ 投稿したトピックが60日以上経過し、合計コメント数が0件の場合は、自動的に投稿は削除されます。ご了承ください。</p>
    </Styled>
  );
};

export default SectionAttention;
